<template>
  <div class="dialog-body">
    <h1>Change password</h1>

    <div class="info-container">
      <div class="form-sec">
        <form
          method="post"
          :action="url"
          oninput="repeatPassword.setCustomValidity(repeatPassword.value != newPassword.value ? 'New Passwords do not match.' : '')"
        >
          <input type="hidden" name="_token" :value="$csrf">
          <div class="form-group">
            <label class="required-label">CURRENT PASSWORD</label>
            <input
              type="password"
              class="form-control col-md-10"
              id="currentPassword"
              placeholder="Current Password"
              name="old_password"
              v-model="currentPassword"
              maxlength="191"
              required
            >
          </div>
          <div class="form-group">
            <label class="required-label">NEW PASSWORD</label>
            <input
              type="password"
              class="form-control col-md-10"
              id="newPassword"
              placeholder="New Password"
              name="password"
              v-model="newPassword"
              maxlength="191"
              required
            >
          </div>
          <div class="form-group">
            <label class="required-label">CONFIRM NEW PASSWORD</label>
            <input
              type="password"
              class="form-control col-md-10"
              id="repeatPassword"
              placeholder="Confirm New Password"
              name="password_confirmation"
              v-model="repeatPassword"
              maxlength="191"
              required
            >
          </div>
          <button type="submit" class="btn btn-blue">CHANGE PASSWORD</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: this.$routes["partner_change_password"],
      old_password: "",
      password: "",
      password_confirmation: "",
      isSubmitting: false,
      errorMessage: "",
      currentPassword: "",
      newPassword: "",
      repeatPassword: "",
    };
  },
  methods: {
    async submitForm(e) {
      e.preventDefault();
      this.isSubmitting = true;
      this.errorMessage = "";
      var result = await this.$asyncPost(this.url, {
        old_password: this.old_password,
        password: this.password,
        password_confirmation: this.password_confirmation
      });
      this.isSubmitting = false;

      if (result.status == "success") {
        Swal.fire({
          type: "success",
          title: "Success",
          text: result.message
        }).then(() => {
          this.$redirect(this.$routes["partner_profile"]);
        });
      } else {
        this.errorMessage = result.message;
      }
    }
  }
};
</script>
